import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M12.4598 5.81702C12.3399 5.96326 12.1599 6.03637 11.9919 6.03637C11.8239 6.03637 11.6439 5.96326 11.5359 5.81702C7.28835 0.54038 -0.222905 3.16043 0.00507243 9.66788C0.185055 14.847 3.7967 17.4061 8.04428 21.0376C9.18416 22.0125 10.588 22.5 12.0039 22.5C13.4197 22.5 14.8356 22.0125 15.9755 21.0255C20.1751 17.394 23.7387 14.847 23.9907 9.81411C24.3027 3.18479 16.6954 0.516007 12.4598 5.81702ZM14.3916 19.2828C13.7317 19.8556 12.8918 20.1602 12.0159 20.1602C11.14 20.1602 10.2881 19.8434 9.60412 19.2585C5.29655 15.566 2.54882 13.604 2.40483 9.59475C2.24885 5.34175 6.8444 3.7941 9.65212 7.27937C10.2161 7.98617 11.08 8.38832 11.9919 8.38832C12.9158 8.38832 13.7797 7.97399 14.3557 7.26719C17.1034 3.83067 21.8069 5.29301 21.5909 9.71662C21.399 13.6528 18.5432 15.6879 14.3916 19.2828Z' />
        </SvgIcon>
    );
});
